import { render, staticRenderFns } from "./RedirectToHome.vue?vue&type=template&id=2218a07a"
import script from "./RedirectToHome.vue?vue&type=script&lang=js"
export * from "./RedirectToHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports